import React, { useCallback } from 'react'

interface IResultCardProps {
    active: boolean;
    level: number;
    maxLevel: number;
    title: string;
    subtitle: string;
    onHandleTabChange: () => void;
}

const ResultNavigationCard = (props: IResultCardProps) => {
    const { active, level, maxLevel, title, subtitle, onHandleTabChange } = props;

    const getIndicatorClass = useCallback(() => {
        if (maxLevel === 4) {
            if (level === 4) return 'good';
            if (level === 3) return 'average';
            if (level === 2) return 'weak';
            if (level === 1) return 'poor';
        } else if (maxLevel === 3) {
            if (level === 3) return 'good';
            if (level === 2) return 'weak';
            if (level === 1) return 'poor';
        }
    }, [maxLevel, level]);

    const indicatorClass = 'immersion__results_navigation_card__indicator_' + getIndicatorClass();
    return (
        <div
            className={`immersion__results_navigation_card`}
            onClick={onHandleTabChange}
        >
            <div className={`immersion__results_navigation_card__indicator ${indicatorClass}`} />

            <div className={`immersion__results_navigation_card__content` + (active ? ' immersion__results_navigation_card__content__active' : '')}>
                <h5 className='immersion__results_navigation_card__content__title'>
                    {title}
                </h5>
                <p className='mice immersion__results_navigation_card__content__subtitle'>
                    {subtitle}
                </p>
            </div>
        </div>
    )
}

export default ResultNavigationCard;